import React, { useState, useEffect, useReducer } from 'react';
import { useAuth } from '../Context';

import { Button, Form, Input, Empty, DatePicker, Row, Col, Select, Typography, Tooltip, Space, Table, Modal, Spin, message, Popover, Avatar, Card, Tag } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { EyeOutlined, DeleteOutlined, InfoOutlined } from '@ant-design/icons';

import { TLPS_LIST, TLPS_LIST_SUCCESS, TLPS_LIST_ERROR, NOTIFICATION_MANAGEMENT_LIST, NOTIFICATION_MANAGEMENT_LIST_SUCCESS, NOTIFICATION_MANAGEMENT_LIST_ERROR, USERS_LIST_SUCCESS, USERS_LIST_ERROR, USERS_LIST }  from './constants';
import { NOTIFICATIONS_LIST, NOTIFICATIONS_LIST_SUCCESS, NOTIFICATIONS_LIST_ERROR  } from './constants';
import { NOTIFICATION_DETAILS, NOTIFICATION_DETAILS_SUCCESS, NOTIFICATION_DETAILS_ERROR  } from './constants';
import { DELETE_NOTIFICATION, DELETE_NOTIFICATION_SUCCESS, DELETE_NOTIFICATION_ERROR } from './constants';

import {} from './constants';
import notificationsReducer from './reducer.js';

import axios from 'axios';
import dayjs from 'dayjs';
import { ColumnWidthOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import moment from 'moment/moment.js';

const { Title } = Typography;
const { TextArea } = Input;

const dateFormat = 'YYYY/MM/DD';

export default function Notifications() {
	const { state } = useLocation();
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const {getRegion, regiondata, getUserAllocation ,getUserAllocationData} = useAuth();
	const [regionId, setRegionId] = useState(state && state.data.regionId ? state && state.data.regionId : null);
	const [tlpId, setTLPId] = useState(null);
	const initalState = {tlps: [], notifications : [],users_data:[], pagination: { total: 0, limit: 10, skip: 0, current:1 }, details: null, pending: false, error: false , stsfilter : []};
	const [data, dispatch] = useReducer(notificationsReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [allocationId, setAllocationId] = useState(state && state.data.regionId ? state && state.data.regionId : null);
	const [notificationId,setNotificationId] = useState(state && state.data.value ? state && state.data.value : null);
	// const [startCh, setStartCh] = useState(null);
	// const [endCh, setEndCh] = useState(null);

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const [alarmCount,setAlarmCount] = useState([]);
	
  
	const today = dayjs();
	const [date, setDate] = useState(today);

	const [showNotificationModal, setShowNotificationModal] = useState(false);
	const [openDeleteNotificationModal, setOpenDeleteNotificationModal] = useState(false);
	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const navigate = useNavigate();
	const settingstimeformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`) == 'undefined' ? envtimeformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_TIME_FORMAT`);
	const envtimeformat = process.env.REACT_APP_TIME_FORMAT == undefined || process.env.REACT_APP_TIME_FORMAT == 'undefined' ? 'HH:mm' : process.env.REACT_APP_TIME_FORMAT;	

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const { RangePicker } = DatePicker;

	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const [startDate, setStartDate] = useState(state && state.data.startdatetime ? customstart ? moment(state && state.data.startdatetime).set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0})  : state && state.data.startdatetime  : customstart ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customstart, 'HH:mm:ss').hour(), minute: moment(customstart, 'HH:mm:ss').minute(),second: moment(customstart, 'HH:mm:ss').second(), millisecond: 0}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	const [endDate, setEndDate] = useState(state && state.data.enddatetime ? customend ?  moment(state && state.data.enddatetime).set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : state && state.data.enddatetime : customend ? moment(new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()), 'YYYY-MM-DD HH:mm:ss').set({ hour: moment(customend, 'HH:mm').hour(), minute: moment(customend, 'HH:mm').minute(),second: moment(customend, 'HH:mm:ss').second(), millisecond: 59}) : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	// const [startDate, setStartDate] = useState(state && state.data.startdatetime ? state && state.data.startdatetime : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate() - 30));
	// const [endDate, setEndDate] = useState(state && state.data.enddatetime ? state && state.data.enddatetime : new Date(new Date().getFullYear(), new Date().getMonth(),  new Date().getDate()));
	const tlpEnabled = 	localStorage.getItem(`${dashboardtype.toUpperCase()}_APP_TLP`) ;
	const stsEnabled = 	localStorage.getItem(`${dashboardtype.toUpperCase()}_APP_STS`);
	const [dashboard , setDashboard] = useState(state && state.data.dashBoardType ? state && state.data.dashBoardType : dashboardtype == 'sts' || stsEnabled == 'true' ? 'sts' : dashboardtype == 'tlp' || tlpEnabled == 'enabled' ? 'tlp' :'oneview'  );
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const [user, setUser] = useState(null);
	
	const ruleTypes = [
		{ value: 1, label: langdata && langdata.CASINGACPICKUP ? langdata.CASINGACPICKUP : 'CASING AC PICKUP' },
		{ value: 2, label: langdata && langdata.ACPICKUP ? langdata.ACPICKUP : 'AC PICKUP' },
		{ value: 3, label: langdata && langdata.CSPDC ? langdata.CSPDC : 'CSP DC' },
		{ value: 4, label: langdata && langdata.PSPDC ? langdata.PSPDC : 'PSP DC' },
		{ value: 5, label: langdata && langdata.BATTERY ? langdata.BATTERY : 'BATTERY' },
		{ value: 6, label: langdata && langdata.TEMPERATURE ? langdata.TEMPERATURE : 'TEMPERATURE' },
		{ value: 7, label: langdata && langdata.CURRENT ? langdata.CURRENT : 'CURRENT' }
	];

	const getRuleType = (index) => {
		let ruleType = ruleTypes.find( (ruleType) => ruleType.value === index);

		return ruleType ? ruleType.label : '<Not Set>';
	};

	const getChainage = (deviceId) => {
		let tlp = data.tlps.find( (tlp) => tlp.deviceId === deviceId);

		return tlp ? tlp.pipelineChainage : '<Not Set>';
	};

	const disabledDate = (current) => {
		// Can not select days before today and today
		return current && current > dayjs().endOf('day');
	};
	const onRangeChange = (dates) => {
		if (dates) {
			if(settingstimeformat.includes(':ss')){
				const isoStartDate = dates && dates[0].$d;
				const isoEndDate = dates && dates[1].$d;
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
		
			}else{
						
				const isoStartDate = moment.utc(dates && dates[0].$d).second(0);
				const isoEndDate = moment.utc(dates && dates[1].$d).second(59);
				setStartDate(isoStartDate);
				setEndDate(isoEndDate);
			}
		} else {
			console.log('Clear');
		}
	};

	let columns = [];
	
	if (dashboard ==='sts' ){
		columns.push(
			{
				title: langdata && langdata.UserName ? langdata.UserName : 'User Name',
				dataIndex: 'userName',
				key: 'userName'
			},
			{
				title: langdata && langdata.NotificationType ? langdata.NotificationType : 'Notification Type',
				dataIndex: 'notificationType',
				key: 'notificationType',
				render: (_, { notificationType }) => (
					<>
						<Tag color={'blue'} >
							{notificationType}
						</Tag>
					</>
				),
			},
			{
				title:  langdata && langdata.Description ? langdata.Description : 'Description',
				dataIndex: 'description',
				key: 'description',
				render: (text) => (
					<Popover overlayStyle={{ width : text.length >= 80 ?  '80%' : '' }}  title={langdata && langdata.Description ? langdata.Description :'Description'} content={text} trigger="hover">
						<Typography.Paragraph
							ellipsis={
								{
									rows: 1,
									expandable: false,
									symbol: ''
								}
							}
						>
							{ text.length >= 80 ? text.slice(0,80) + '...' : text.slice(0,80)}
						</Typography.Paragraph>
					</Popover>
				)

			},
			{
				title: langdata && langdata.DateTime ? langdata.DateTime : 'Date',
				dataIndex: 'datetime',
				key: 'datetime'
			},
			{
				title: langdata && langdata.Region ? langdata.Region : 'Date',
				dataIndex: 'regionName',
				key: 'regionName'
			},
			// {
			// 	title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			// 	key: 'action',
			// 	render: () => (
			// 		<Space size="middle">
			// 			<a title={langdata && langdata.DeleteNotification ? langdata.DeleteNotification : 'Delete Notification'} onClick={showDeleteNotificationModal}><DeleteOutlined /></a>
			// 			{/* <a title={langdata && langdata.ViewNotification ? langdata.ViewNotification : 'View Notification'} onClick={openNotificationModal}><EyeOutlined /></a> */}
			// 		</Space>
			// 	)
			// }
		);
	}else if (dashboard ==='tlp'){
		columns.push(
			{
				title: langdata && langdata.Device ? langdata.Device : 'Device',
				dataIndex: 'deviceId',
				key: 'deviceId',
				render: (text) => <span onClick={openNotificationModal}>{text}</span>,
			},
			{
				title:  langdata && langdata.NotificationType ? langdata.NotificationType : 'Notification Type',
				dataIndex: 'notificationType',
				key: 'notificationType',
				render: (_, { notificationType }) => (
					<>
						{ruleTypes.map((type) => {
							if (notificationType ===  type.value) {
								return (
								// eslint-disable-next-line react/jsx-key
									<div>
										{type.label}
									</div>
								); 
							} else {
								return '';
							}
						})}
					</>
				)
			},
			{
				title:  langdata && langdata.Message ? langdata.Message : 'Message',
				dataIndex: 'message',
				key: 'message',
			},
			{
				title: langdata && langdata.Date ? langdata.Date : 'Date',
				dataIndex: 'createdAt',
				key: 'createdAt'
			},
			{
				title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
				key: 'action',
				render: () => (
					<Space size="middle">
						<a title={langdata && langdata.ViewNotification ? langdata.ViewNotification : 'View Notification'} onClick={openNotificationModal}><EyeOutlined /></a>
						<a title={langdata && langdata.DeleteNotification ? langdata.DeleteNotification : 'Delete Notification'} onClick={showDeleteNotificationModal}><DeleteOutlined /></a>
					</Space>
				)
			} );
	}


	const openNotificationModal = () => {
		setShowNotificationModal(true);
	};

	const closeNotificationModal = () => {
		setShowNotificationModal(false);
	};
  
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		if(permission == 'superadmin' || permission == 'admin'){
			getRegion(authtoken);
		}
		else{
			getUserAllocation(authtoken);
		}
		loadTLPs();
		// if(dashboard ==='sts'){
		// 	loadSTSNotifications();  
		// } else if (dashboard ==='tlp'){
		// 	loadNotifications();
		// }
		loadSTSFilter();
		
	}, [regionId, allocationId]);

	useEffect(()=>{
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '0');
		loadAlarmCount();
	},[]);

	useEffect(() => {
		if(featuresModule.notificationsEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
	

		if(dashboard ==='sts' && ((stsEnabled == 'true' && (dashboardtype =='tlp' || dashboardtype =='oneview')) || dashboardtype =='sts') ){
			loadSTSNotifications(1);  
		} else if (dashboard ==='tlp' && ((tlpEnabled == 'enabled' && (dashboardtype  =='sts' || dashboardtype =='oneview')) || dashboardtype  =='tlp')){
			loadNotifications(1);
		}else if(dashboard == 'oneview'){
			loadOneviewNotifications();
		}
		usersList();
	}, [regionId, tlpId, date,dashboard,startDate,endDate,notificationId, allocationId,user]);

	
	let regions = [ { value: null, label: `${langdata && langdata.ALL ? langdata.ALL:'ALL'}`} ];
	let tlps = [ { value: null, label: `${langdata && langdata.ALL ? langdata.ALL:'ALL'}`} ];

	if(permission == 'superadmin' || permission == 'admin'){
		regiondata && regiondata.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		});
	} else {
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regioninfo.regionName +'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
				region: region.regioninfoId,
				pipelineConfigFrom : region.pipelineConfigFrom,
				pipelineConfigTo : region.pipelineConfigTo
			});
		});
	}

	data && data.tlps && data.tlps.map((tlp) => {
		return tlps.push({ value: tlp.deviceId, label: tlp.pipelineChainage.toString() });
	});

	const handleChangeRegion = (e,options) => {
		if(permission == 'superadmin' || permission == 'admin') {
			setRegionId(e);
		} else {
			setAllocationId(e);
			setRegionId(options.region);
			// setStartCh(options.pipelineConfigFrom);
			// setEndCh(options.pipelineConfigTo);
		}
	};

	const handleChangeTLP = (e) => {
		localStorage.setItem(`${dashboardtype}_TLP_ID`, e);
		setTLPId(e);
	};

	const handleDateChange = (date, dateString) => {
		try {
			let newDate = dayjs(dateString);

			if (!dateString || dateString.length === 0) {
				newDate = dayjs();

				setDate(newDate);
			} else {
				setDate(newDate);
			}
		} catch(e) {
			console.log('# New date is invalid');
		}
	};

	const loadTLPs = () => {
		dispatch({ type: TLPS_LIST });

		const limit = 10000;
		const skip = 0;
    
		let allocationParams = '';
		if(admin_roles.includes(permission)){
			allocationParams = regionId ? `&regioninfoId=${regionId}` : '';
		}
		else{
			allocationParams = allocationId ? `&allocationId=${allocationId}` : '';
		}

		let url = `${api}/smarttlp-list?${allocationParams}&$limit=${limit}&$skip=${skip}&$sort[pipelineChainage]=-1`;

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			timeout: timeout,
			headers: {
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			}
		};

		axios.request(config).then((response) => {
			if (response && response.data) {
				dispatch( { type: TLPS_LIST_SUCCESS, payload: response.data });
			} else {
				dispatch( { type: TLPS_LIST_ERROR });
			}
		}).catch((error) => {
			console.log(error);
			dispatch( { type: TLPS_LIST_ERROR });
			if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
				message.config({
					duration : 5,
					maxCount : 1,
				});
				message.open({
					type: 'error',
					content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
				});
			}
		});
	};

	const loadNotifications = (pagination) => {
		let _pagination = { };
    
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination && pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;

		// const usertypeparams = usertypeId && usertypeId == 'All' ? '&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13' : usertypeId=='Linewalker' ? 'usertypeId=4' : usertypeId=='NPV' ? 'usertypeId=7' : usertypeId=='QRT' ? 'usertypeId=13' : '';

        
		let url = `${api}/notification-list?$limit=${_pagination.limit}&$skip=${_pagination.skip}`;

		if (tlpId !== null) {
			url += `&deviceId=${tlpId}`;
		}

		if (date) {
			let utc = require('dayjs/plugin/utc');

			dayjs.extend(utc);

			let startDate = dayjs(date).utc(true).format('YYYY-MM-DD 00:00:00');
			let enddDate = dayjs(date).utc(true).format('YYYY-MM-DD 23:59:59');

			url += `&createdAt[$gt]=${startDate}&&createdAt[$lt]=${enddDate}`;
		}

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
    
		dispatch({ type: NOTIFICATIONS_LIST });
    
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:NOTIFICATIONS_LIST_SUCCESS, payload: response.data, page:pagination.current ,project_type : 'TLP'});
				} else {
					dispatch({type:NOTIFICATIONS_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:NOTIFICATIONS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadNotificationDetails = ((record) => {
	
		dispatch({ type: NOTIFICATION_DETAILS });

		if (record) {
			dispatch({ type: NOTIFICATION_DETAILS_SUCCESS, payload: record });
    
		} else {
			dispatch({ type: NOTIFICATION_DETAILS_ERROR });
		}
	});


	const showDeleteNotificationModal = () => {
		setOpenDeleteNotificationModal(true);
	};

	const cancelDeleteNotification = () => {
		setOpenDeleteNotificationModal(false);
	};

	const deleteNotification = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_NOTIFICATION });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/notification/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_NOTIFICATION_SUCCESS, payload:response});
					setOpenDeleteNotificationModal(false);  
					loadNotifications(1);        
				} else {
					dispatch({type: DELETE_NOTIFICATION_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type: DELETE_NOTIFICATION_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	const handleNotificationtype = (e) => {

		setNotificationId(e); 
	};

	const handleChangeDashboard = (e) => {
		setDashboard(e);
		// dispatch({ type: CLEAR_THE_NOTIFICATIONS });


	};
	let dashop = [  ];
	
	let notificationTypes =  [{
		value :null, label :`${langdata && langdata.ALL ? langdata.ALL:'ALL'}`
	}];

	data.stsfilter && data.stsfilter.map((item)=>{
		notificationTypes.push({
			value :item.value ,
			label : `${item.label}`
		});
	});



	if(dashboardtype.toLowerCase() === 'sts' || stsEnabled === 'true'){
		dashop.push(
			{
				value: 'sts',
				label: 'STS',
			});
	}
	

	if (dashboardtype.toLowerCase() === 'tlp' ||  tlpEnabled === 'enabled'){
		dashop.push(
			{
				value: 'tlp',
				label: 'TLP',
			} );

	}
	if(dashboardtype.toLowerCase() == 'oneview'){
		dashop.push(

			{
				value: 'oneview',
				label: 'OneView',
			}
		);
	}


	const loadOneviewNotifications = () =>{
		dispatch({type:NOTIFICATIONS_LIST_SUCCESS, payload: {data :[]} , project_type :'ONEVIEW'});
	};

	const loadSTSNotifications = (pagination) => {

		let _pagination = { };
    
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination && pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		let url;
		let params = '';
		// if(regionId!=null){
		// 	params += `&regioninfoId=${regionId}`;

		// }
		if(notificationId!=null){
			params += `&notificationtypeId=${notificationId}`;
		}

		let allocationParams = '';
		if(regionId !=null){
			if(admin_roles.includes(permission)){
			// getRegion(authtoken);
				allocationParams = `&regioninfoId=${regionId}`;
			}
			else{
			// getUserAllocation(authtoken);
				allocationParams = `&allocationId=${allocationId}`;
			}
		}
		// let usertypeparams = '';
		// if(usertypeId == 'Linewalker'){
		// 	usertypeparams = '&usertypeId=4';
		// }else if(usertypeId == 'NPV'){
		// 	usertypeparams = '&usertypeId=7';
		// }else if(usertypeId == 'QRT'){
		// 	usertypeparams = '&usertypeId=13';
		// }

		let userParams = '';
		if(user){
			userParams =`&userId=${parseInt(user)}`;
		}


		

		url = `${api}/stsnotification-list?pipelineId=${pipelineId}${allocationParams}${params}${userParams}&$limit=${_pagination.limit}&$skip=${_pagination.skip}`;
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url +=`&$sort[id]=-1&datetime[$gte]=$${moment.utc(startDate).toISOString()}&datetime[$lte]=${moment.utc(endDate).toISOString()}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
    
		dispatch({ type: NOTIFICATIONS_LIST });
    
		axios
			.request(config)
			.then((response) => {
				

				if (response.status === 200) {
					dispatch({type:NOTIFICATIONS_LIST_SUCCESS, payload: response.data , page:pagination.current, project_type :'STS'});
				} else {
					dispatch({type:NOTIFICATIONS_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:NOTIFICATIONS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
		
	};

	const loadSTSFilter = ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/stsnotificationtype/?pipelineId=${pipelineId}&$sort[id]=1`,
			timeout: timeout,
			headers: {
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			},
		};
		dispatch({type : NOTIFICATION_MANAGEMENT_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });
				}
			});
	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.NotificationInfoContent ? langdata.NotificationInfoContent : 'Smart TLP notifications generated by the TLP Rule Engine will be displayed here, along with OneView notifications and STS notifications for various notification types.'}</p>
		</Card>
	);
	const loadAlarmCount = () => {
	
		if(dashboardtype =='sts' || stsEnabled == 'true' ){
	
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/stsnotification-list?pipelineId=${pipelineId}&adminStatus=false`,
				// timeout: process.env.REACT_APP_TIMEOUT,
				headers: { 
					Authorization:`Bearer ${authtoken}`  
				}
			};
			
			axios.request(config)
				.then((response) => {
					if(response.status === 200) {
						setAlarmCount(response.data.data);
						// setNewNotification(response.data);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
			
	};

	// const updateAlarmCount = () => {
	// 	let params = new URLSearchParams();
	// 	// console.log(alarmCount);
		
		
		
	// 	alarmCount.forEach((alarm)=>{
	// 		if(alarmCount.length ==1){
	// 			params = '';
	// 			params = `${alarm.id}`;
	// 		}
	// 		else{
	// 			params.append('id[$in]', alarm.id);
	// 		}
			
	// 	});
		
	
	// 	if(dashboardtype ==='sts' || stsEnabled == 'true'  && params ){
	
	// 		let config = {
	// 			method: 'patch',
	// 			maxBodyLength: Infinity,
	// 			url: `${api}/stsnotification${alarmCount.length==1 ? '/' : '?'}${params.toString()}`,
	// 			// timeout: process.env.REACT_APP_TIMEOUT,
	// 			headers: { 
	// 				Authorization:`Bearer ${authtoken}`  
	// 			},
	// 			data : {
	// 				adminStatus : true
	// 			}
	// 		};
			
	// 		axios.request(config)
	// 			.then((response) => {
	// 				if(response.status === 200) {
	// 					// loadAlarmCount();
	// 				}
	// 			})
	// 			.catch((error) => {
	// 				console.log(error);
	// 			});
	// 	}
	// };



	const updateAlarmCount = () => {
	
		if(dashboardtype ==='sts' || stsEnabled == 'true' && alarmCount.length>=1){
			
	
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/bulkupdate`,
				// timeout: process.env.REACT_APP_TIMEOUT,
				headers: { 
					Authorization:`Bearer ${authtoken}`  
				},
				data : {
					id:alarmCount.map(a=>a.id),
					adminStatus : true
				}
			};
			
			axios.request(config)
				.then((response) => {
					if(response.status === 200) {
						// loadAlarmCount();
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};
  
	
	useEffect(()=>{
		if(alarmCount.length > 0){
			updateAlarmCount();
		}
	},[alarmCount]);

	let users=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];
	
	data.users_data && data.users_data.map((user)=>{
		users.push({
			value:user.id,
			label:user.firstName.toUpperCase()+ ' ' +user.lastName.toUpperCase()

		});
	});

	const handleSetUser = (e) =>{
		setUser(e);
	};

	const usersList = () => {

		dispatch({ type : USERS_LIST});

		const usertypeparams = '&usertypeId[$in][]=4&usertypeId[$in][]=7&usertypeId[$in][]=13'; 
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation-list?${usertypeparams}&isDeleted=false`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : USERS_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : USERS_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	};

	const getDateWithTime = (date, time) => {
		if (!time) return date;

		const [hour, minute, second] = time.split(':').map(Number);

		return dayjs(date)
			.set('hour', hour)
			.set('minute', minute)
			.set('second', second);
	};
	
	return (
		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={4}>
						<Row>
							<Space>
								<ColumnWidthOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							{/* <Col style={{marginLeft:'4px'}} span={19}> */}
							<Title level={4} style={{ paddingTop:'10px'}}> { langdata && langdata.Notifications ? langdata.Notifications : 'Notifications' }</Title>
						</Row>
					</Col>
					
					<Col span={20}>
						<Row justify="end"  gutter={[8, 8]} wrap>
							<Col>
								{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>Region:</Text> */}
								<Tooltip placement="bottom" title={ 'Change dashboard type'}>
									<Space>
										<Select
											style={{ minWidth: 150,margin: '5px' }}
											showSearch
											filterOption={filterOption}
											// placeholder={ langdata && langdata.SelectRegion ? langdata.SelectRegion : 'Select Region'}
											optionFilterProp="children"
											defaultValue={dashboard}
											// value={regionId}
											options={dashop}
											onSelect={(e, options)=>handleChangeDashboard(e, options)}
										/>
									</Space>
								</Tooltip>
								{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>Region:</Text> */}
								<Tooltip placement="bottom" title={ langdata && langdata.Filterbyregion ? langdata.Filterbyregion : 'Filter by region'}>
									<Space>
										<Select
											style={{ minWidth: 150,margin: '5px' }}
											showSearch
											filterOption={filterOption}
											placeholder={ langdata && langdata.SelectRegion ? langdata.SelectRegion : 'Select Region'}
											optionFilterProp="children"
											defaultValue={null}
											// value={regionId}
											value={ admin_roles.includes(permission) ? regionId : allocationId }

											options={regions}
											onSelect={(e, options)=>handleChangeRegion(e, options)}
										/>
									</Space>
								</Tooltip>
								{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>Chainage:</Text> */}
								{ dashboard === 'tlp' ?
									<Tooltip placement="bottom" title={ langdata && langdata.Filterbychainage ? langdata.Filterbychainage : 'Filter by chainage'}>
										<Space>
											<Select
												style={{ minWidth: 150, margin: '5px' }}
												showSearch
												filterOption={filterOption}
												placeholder={ langdata && langdata.SelectChainage ? langdata.SelectChainage : 'Select Chainage'}
												optionFilterProp="children"
												defaultValue={'ALL'}
												value={tlpId}
												options={ tlps }
												onSelect={handleChangeTLP}
											/>
										</Space>

									</Tooltip>
									: null
								}
								{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>Date:</Text> */}
								{	dashboard === 'sts' ? 

									<>
										<Tooltip placement="bottom" title={ langdata && langdata.FilterByNotificationType ? langdata.FilterByNotificationType : 'Filter by notification type'}>
											<Space>
												<Select
													style={{ minWidth: 150,margin: '5px' }}
													showSearch
													filterOption={filterOption}
													// placeholder={ langdata && langdata.SelectRegion ? langdata.SelectRegion : 'Select Region'}
													optionFilterProp="children"
													defaultValue={'ALL'}
													value={notificationId}
													options={notificationTypes}
													onSelect={(e)=>{handleNotificationtype(e);}}
												/>
											</Space>
										</Tooltip>
										<Tooltip placement="bottom" title={langdata && langdata.FilterbyUser ? langdata.FilterbyUser :'Filter by User'}>
										
											<Space>
												<Select Item
													style={{ minWidth: 150,margin: '5px' }}
													showSearch
													filterOption={filterOption}
													placeholder={langdata && langdata.SelectUsers ? langdata.SelectUsers :'Select Users'}
													optionFilterProp="children"
													// onChange={onChange}
													// onSearch={onSearch}
													// filterOption={filterOption}
													defaultValue={null}
													options={users}
													onSelect={handleSetUser}
										
												/>  
											</Space>
										</Tooltip>  
										<Space>&nbsp;&nbsp;</Space> 
										
									
										<Space>
																		
											<Tooltip title={langdata?.Selectdate || 'Select date'}>
												<RangePicker
													onChange={onRangeChange}
													disabledDate={disabledDate}
													allowClear={false}
													showTime
													format={`${settingsdateformat} ${settingstimeformat}`}
													defaultValue={[
														getDateWithTime(state && state.data.startdatetime ?  state && state.data.startdatetime  : dayjs().subtract(30, 'day'), customstart),
														getDateWithTime(state && state.data.enddatetime ?  state && state.data.enddatetime  : dayjs(), customend)
													]}
												/>
											</Tooltip>
										</Space>
								
									</>
								
									:
									<Tooltip placement="bottom" title={ langdata && langdata.Filterbydate ? langdata.Filterbydate : 'Filter by date'}>
										<Space>
											<DatePicker
												allowClear={false}
												style={{margin:'5px'}} 
												format = {dateFormat} 
												value={date}
												defaultValue={dayjs()}
												onChange={handleDateChange}
											/>
										</Space>
									</Tooltip>}
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={ langdata && langdata.Notifications ? langdata.Notifications : 'Notifications'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{data.notifications && data.notifications.length > 0 ? (
							dashboard === 'sts' ? (
								<Table
									scroll={{ x: 900 }}
									columns={columns}
									dataSource={data.notifications}
									onChange={loadSTSNotifications}
									pagination={data.notifications.length > 0 ? data.pagination : false}
									onRow={(record) => ({
									
									
										onClick: () => loadNotificationDetails(record),
									})}
								/>
							) : (
								<Table
									scroll={{ x: 900 }}
									columns={columns}
									dataSource={data.notifications}
									pagination={data.notifications.length > 0 ? data.pagination : false}
									onChange={loadNotifications}
									onRow={(record) => ({
										onClick: () => loadNotificationDetails(record),
									})}
								/>
							)
						) : (
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.pending} />

			{/* Notification Details Modal Starts */}
			<Modal
				title={ langdata && langdata.NotificationDetails ? langdata.NotificationDetails : 'Notification Details'}
				centered
				destroyOnClose={true}
				open={showNotificationModal}
				onOk={{closeNotificationModal}}
				onCancel={closeNotificationModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button key="submit" type="primary" onClick={closeNotificationModal}>
              CLOSE
						</Button>
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical">
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item name="chainageId" label={ langdata && langdata.Chainage ? langdata.Chainage : 'Chainage'} >
								<Input disabled={true} placeholder={ langdata && langdata.Chainage ? langdata.Chainage : 'Chainage'}  defaultValue={ data.details && data.details.deviceId && getChainage(data.details.deviceId)} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="deviceId" label={ langdata && langdata.DeviceID ? langdata.DeviceID : 'Device ID'} >
								<Input disabled={true} placeholder={ langdata && langdata.DeviceID ? langdata.DeviceID : 'Device ID'} defaultValue={ data.details && data.details.deviceId} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item name="notificationType" label={ langdata && langdata.NotificationType ? langdata.NotificationType : 'Notification Type'} >
								<Input disabled={true} placeholder={ langdata && langdata.NotificationType ? langdata.NotificationType : 'Notification Type'} defaultValue={ data.details && data.details.notificationType && getRuleType(data.details.notificationType)} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="createdAt" label={ langdata && langdata.Date ? langdata.Date : 'Date' }>
								<Input disabled={true} placeholder={ langdata && langdata.Date ? langdata.Date : 'Date' }  defaultValue={ data.details && data.details.createdAt} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={24}>
							<Form.Item name="message" label={ langdata && langdata.Message ? langdata.Message : 'Message'} >
								<TextArea disabled={true} rows="5" placeholder={ langdata && langdata.Message ? langdata.Message : 'Message'} defaultValue={ data.details && data.details.message} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
			{/* Notification Details Modal Ends */}
            
			{/* Delete Modal Starts */}
			<Modal title={ langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={openDeleteNotificationModal} onOk={deleteNotification} onCancel={cancelDeleteNotification}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>
						{ langdata && langdata.Areyousureyouwanttodeletethisnotification ? langdata.Areyousureyouwanttodeletethisnotification : 'Are you sure you want to delete this notification?'}
					</Col>
				</Row>
			</Modal>
			{/* Delete Modal Ends */}
		</>
	);
}